<template>
  <page-wrapper background="/static/img/anniversary/page-final/bg.png" :swiper="swiper" :has-down-btn="true">
    <div swiper-animate-effect="animate__fadeIn" class="main-image-text-bg ani" style="background: url(/static/img/anniversary/page-final/text-bg.png); background-size: cover;">
      <div class="main-image-text-inner">
        <div class="main-text ani" swiper-animate-effect="animate__fadeIn">
          亲爱的<span class="text-highline">{{data.customerName || customerName}}</span>老师<br />
          <span class="text-highline">{{data.registrationDate || customerCreateDT}}</span><br />
          第一次与吉凯相遇<br />
          <p class="active-details" v-if="data.campaignTimes">参加过<span class="text-highline">{{getText(data.campaignTimes)}}</span>市场活动</p>
          <p class="active-details" v-if="data.firstContractDate"><span class="text-highline">{{getText(data.firstContractDate)}}</span>签订第一个合同</p>
          <p class="active-details" v-if="data.purchaseTimes">一共购买过<span class="text-highline">{{getText(data.purchaseTimes)}}</span>产品或服务</p>
          <p class="active-details" v-if="data.amount">合同总金额<span class="text-highline">{{getText(data.amount)}}</span></p>
        </div>
      </div>
    </div>
    <img swiper-animate-effect="animate__fadeIn" class="pic-final ani"  src="/static/img/page-key-words-result/4.png"/>
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'
import {mapGetters} from 'vuex'

export default {
  components: { PageWrapper },
  data () {
    return {
      hide: false,
      modalShow: false
    }
  },
  computed: {
    ...mapGetters(['customerName', 'customerCreateDT']),
    showLogo () {
      console.log('window.innerHeight', window.innerHeight)
      return window.innerHeight > 720
    }
  },
  methods: {
    handleHide (i) {
      this.hide = i
    },
    getText (text) {
      return this.hide ? '****' : text
    },
    handleOpenModal () {
      this.modalShow = !this.modalShow
    }
  },
  props: [
    'swiper', 'data'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .active-details {
    margin: 0;
  }
  .pic-final {
    position: absolute;
    left: 45vw;
    top: 95.472vw;
    width: 50.54vw;
    height: 50.54vw;
    opacity: 1;
    z-index: 999;
  }
  .main-image-logo {
    position: absolute;
    bottom: 57px;
    //left: 50vw;
    //margin-left: -23.865*1.2vw;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;

    img{
      width: 47.73*1.2vw;
      height: 13.33*1.2vw;
      z-index: 99;
    }
  }

  .main-image-text-bg {
    position: absolute;
    left: 0px;
    top: 15vw;
    width: 87.2vw;
    height: 122.672vw;
    z-index: 1;

    .main-image-text-inner {
      width: 87.2vw;
      height: 122.672vw;
      position: relative;

      .main-text {
        position: absolute;
        left: 50%;
        top: 15px;
        width: 73vw;
        font-size: 4.26vw;
        line-height: 9.33vw;
        font-weight: 400;
        margin-left: -35.6vw;
        letter-spacing: -0.3px;
        z-index: 99;

        /* 字体 */
        color: #193543;

        .text-highline {
          font-size: 22px;
          font-weight: 600;
        }

        .text-notice {
          font-size: 16px;
          font-weight: 400;
        }
      }

      .main-image-second-text {
        position: absolute;
        left: 8.533333333vw;
        bottom: 35px;
        //top: 334px;
        width: 36.8vw;
        height: 26.93333333vw;
        z-index: 90;
      }
      .main-image-second-text-right {
        position: absolute;
        right: 6vw;
        bottom: 35px;
        //top: 334px;
        width: 30vw;
        height: 30vw;
        z-index: 90;
      }
      .code-text {
        position: absolute;
        left: 8.533333333vw;
        bottom: 1px;
        z-index: 90;
        font-size: 12px;
      }
    }
  }

  .dialog-wrapper {
    background: white;
    position: relative;
    width: 61.33vw;
    height: 80.8vw;
    border-radius: 5.33vw;
    overflow: hidden;

    .main-image-qrcode {
      position: absolute;
      left: 50%;
      top: 4.266666667vw;
      margin-left: -26.65vw;
      width: 53.3vw;
      height: 53.3vw;
    }

    .dialog-text {
      position: absolute;
      left: 50%;
      bottom: 5.6vw;
      width: 56vw;
      margin-left: -28vw;
      height: 14.4vw;
      font-size: 16px;
      font-weight: normal;
      line-height: 27px;
      letter-spacing: -0.3px;
      color: #3D3D3D;
      text-align: center;
    }
  }

  .close-btn {
    position: absolute;
    bottom: -12vw;
    left: 50%;
    width: 9vw;
    height: 9vw;
    margin-left: -4.5vw;
  }

  .main-image-hide-btn {
    position: absolute;
    width: 6.4vw;
    height: 6.4vw;
    left: 57.06666667vw;
    top: 36px;
    z-index: 80;
  }

  .main-text-background {
    position: absolute;
    left: 50%;
    bottom: -15.2vw;
    width: 82.1vw;
    margin-left: -41.05vw;
    height: 121.8666667vw;
    z-index: 98;
  }

  .main-image-shape1 {
    position: absolute;
    right: 8px;
    top: 420px;
    width: 50vw;
    height: 50vw;
    z-index: 88;
  }

  .main-image-mini-qrcode {
    position: absolute;
    right: 70px;
    top: 300px;
    width: 30vw;
    height: 30vw;
    z-index: 88;
    //position: absolute;
    //right: 8px;
    //top: 400px;
    //width: 85.86vw;
    //margin-left: -42.93vw;
    //height: 22.93333333vw;
  }

  .sub-text {
    //position: absolute;
    //left: 50vw;
    //bottom: 9vw;
    //margin-left: -42.4vw;
    margin-left: 30px;
    width: 84.8vw;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    line-height: 27px;
    letter-spacing: -0.3px;
    text-align: left;
    a {
      text-decoration: underline;
    }
  }

  .sub-notice {
    //position: absolute;
    margin-left: 30px;
    //bottom: 5vw;
    width: 84.8vw;
    height: 7vw;
    font-family: PingFangSC-Regular;
    font-size: 2.666666667vw;
    font-weight: normal;
    line-height: 15px;
    letter-spacing: -0.3px;
    color: rgba(93, 133, 234, 0.66);
  }
}


</style>



// WEBPACK FOOTER //
// index.vue?dce42d46